import React, { useState, useEffect } from 'react';
import { Card, Typography, Switch, Row, Col, Button, Space, InputNumber, message, Divider, Tag } from 'antd';
import { SaveOutlined, SafetyOutlined, MessageOutlined, TeamOutlined, CameraOutlined, AppstoreOutlined, ScanOutlined, UserAddOutlined } from '@ant-design/icons';
import api from '../api';

const { Title, Text } = Typography;

const configItems = [
  { key: 'enableRegistration', label: '开放注册', desc: '允许新用户注册账号', icon: <UserAddOutlined />, color: '#07C160' },
  { key: 'enableChat', label: 'IM 聊天', desc: '启用单聊和群聊功能', icon: <MessageOutlined />, color: '#10AEFF' },
  { key: 'enableGroupChat', label: '群聊功能', desc: '允许创建群组和群聊', icon: <TeamOutlined />, color: '#FA9D3B' },
  { key: 'enableMoments', label: '朋友圈', desc: '启用朋友圈发布和浏览', icon: <CameraOutlined />, color: '#FA9D3B' },
  { key: 'enableMiniProgram', label: '小程序', desc: '启用小程序沙箱引擎', icon: <AppstoreOutlined />, color: '#6467F0' },
  { key: 'enableVideoCall', label: '音视频通话', desc: '允许发起语音/视频通话', icon: <CameraOutlined />, color: '#10AEFF' },
  { key: 'enableScanAddFriend', label: '扫码加好友', desc: '允许扫描二维码添加好友', icon: <ScanOutlined />, color: '#07C160' },
];

function OperationConfigPage() {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const loadConfig = async () => {
    setLoading(true);
    try {
      const { config: c } = await api.get('/admin/operation-config');
      setConfig(c || {});
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadConfig(); }, []);

  const handleToggle = (key) => {
    setConfig({ ...config, [key]: !config[key] });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/admin/operation-config', config);
      message.success('运营配置已保存');
    } catch (e) {
      message.error('保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={4}>运营配置</Title>
        <Button type="primary" icon={<SaveOutlined />} onClick={handleSave} loading={saving} style={{ background: '#07C160' }}>保存配置</Button>
      </div>

      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        控制 App 内各功能的开关。关闭后，客户端将隐藏或禁用相应功能。
      </Text>

      <Row gutter={16}>
        {configItems.map((item) => (
          <Col span={8} key={item.key} style={{ marginBottom: 16 }}>
            <Card
              hoverable
              size="small"
              title={
                <Space>
                  <span style={{ color: item.color }}>{item.icon}</span>
                  <Text strong>{item.label}</Text>
                </Space>
              }
              extra={
                <Switch
                  checked={config[item.key] !== false}
                  onChange={() => handleToggle(item.key)}
                  checkedChildren="开"
                  unCheckedChildren="关"
                />
              }
            >
              <Text type="secondary" style={{ fontSize: 13 }}>{item.desc}</Text>
              <div style={{ marginTop: 8 }}>
                {config[item.key] !== false ? <Tag color="green">已启用</Tag> : <Tag color="default">已禁用</Tag>}
              </div>
            </Card>
          </Col>
        ))}

        <Col span={8} style={{ marginBottom: 16 }}>
          <Card
            hoverable
            size="small"
            title={
              <Space>
                <span style={{ color: '#FA9D3B' }}><TeamOutlined /></span>
                <Text strong>最大群成员数</Text>
              </Space>
            }
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              <InputNumber
                value={config.maxGroupMembers || 500}
                onChange={(v) => setConfig({ ...config, maxGroupMembers: v })}
                min={2}
                max={5000}
                style={{ width: '100%' }}
              />
              <Text type="secondary" style={{ fontSize: 12 }}>限制每个群组的成员上限</Text>
            </Space>
          </Card>
        </Col>
      </Row>

      <Card size="small" style={{ background: '#fff7e6', border: '1px solid #ffd591' }}>
        <Text type="secondary">
          ⚠️ 注意：关闭功能后，客户端将实时响应。已登录用户可能需要刷新或重新进入页面才能看到变化。
        </Text>
      </Card>
    </>
  );
}

export default OperationConfigPage;
